import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

export const analytics = [
  {
    path: '/analytics',
    name: ERouterList.ANALYTICS,
    component: () => import('@internal/pages/analytics/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default analytics
